import { API_BASE_URL, SSH_WEB_PROXY } from '@config';
import store from 'app/store';
import axios from 'axios';
import * as React from 'react';
import { XTerm } from 'xterm-for-react';

const Terminal = () => {
  const xtermRef = React.useRef(null)
  React.useEffect(() => {
    let purl;
    let isMounted = true
    if (SSH_WEB_PROXY) {
      purl = new URL(SSH_WEB_PROXY);
    } else {
      purl = new URL(API_BASE_URL);
      purl.protocol = purl.protocol === 'https:' ? 'wss:' : 'ws:';
      purl.port = '2200';
    }

    let webSocket;
    if (purl.protocol === 'wss:') {
      webSocket = new WebSocket(purl, 'ssh', { rejectUnauthorized: false });
    } else {
      webSocket = new WebSocket(purl);
    }

    xtermRef.current.terminal.onData((data) => {
      //send data to server
      webSocket.send(data);
    });

    webSocket.addEventListener('open', async () => {
      const url = `${API_BASE_URL}/api/users/downloadUserSSHKey`;
      const request = await axios.get(url);
      const username = store.getState().auth.user.username;
      webSocket.send(`${username}:${request.data}`);
    });

    const handleMessage = (event) => {
      if (isMounted && xtermRef.current) {
        xtermRef.current.terminal.write(event.data);
      }
    };

    webSocket.addEventListener('message', handleMessage);

    return () => {
      isMounted = false;
      webSocket.removeEventListener('message', handleMessage);
      webSocket.close();
    };
  }, [])


  return (
    // Create a new terminal and set it's ref.
    <XTerm ref={xtermRef} options={{ rows: 29, cols: 80 }} />
  )
}
export default Terminal;
